import type { ReactNode } from 'react';
import { NewTaskDotBackground } from './NewTaskDotBackground';

/** Shared page backdrop. Content remains above the decorative, inert canvas. */
export function WorkspaceSurface({ children, animated = true, viewKey = 'page' }: {
  children: ReactNode;
  animated?: boolean;
  viewKey?: string;
}) {
  return (
    <div className="workspace-surface" data-testid="workspace-surface">
      {animated && <NewTaskDotBackground key={viewKey} />}
      <div className="workspace-surface-content">{children}</div>
    </div>
  );
}
